import { createI18n } from 'vue-i18n'
import { App } from 'vue'
import messages from '@intlify/unplugin-vue-i18n/messages'
import { useStorage } from '@vueuse/core'

const defaultLocale = useStorage('locale', import.meta.env.VITE_APP_LANG)

export const i18n = createI18n({
  locale: defaultLocale.value,
  legacy: false, // используем Composition API режим
  globalInjection: true,
  messages,
})

export const { t, locale, availableLocales } = i18n.global

export default (app: App): void => {
  app.use(i18n)
}
